import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Download: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4646 9.25885L10.5 12.2234L7.53543 9.25885"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 3.33057V12.2234"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M17.1695 13.7048C17.1695 15.3421 15.8422 16.6693 14.2049 16.6693H6.79513C5.15785 16.6693 3.83057 15.3421 3.83057 13.7048"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
